var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.173,6.575A5.425,5.425,0,1,0,21.6,12,5.432,5.432,0,0,0,16.173,6.575Zm0,9.6A4.173,4.173,0,1,1,20.346,12,4.178,4.178,0,0,1,16.173,16.173Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,11.74V9.705a.626.626,0,1,0-1.252,0V12a.625.625,0,0,0,.183.442L17.191,13.9a.626.626,0,0,0,.885,0,.628.628,0,0,0,0-.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.13,18.71a.626.626,0,0,0-.626.626v.421a1,1,0,0,1-.988,1.006H4.642a1,1,0,0,1-.988-1.006V4.243a1,1,0,0,1,.988-1.006h.473a.627.627,0,0,1,.626.626A1.462,1.462,0,0,0,7.2,5.323h3.756a1.462,1.462,0,0,0,1.46-1.46.627.627,0,0,1,.626-.626h.473A1,1,0,0,1,14.5,4.243v.421a.626.626,0,1,0,1.251,0V4.243a2.251,2.251,0,0,0-2.239-2.258H4.642A2.252,2.252,0,0,0,2.4,4.243V19.757a2.252,2.252,0,0,0,2.24,2.258h8.874a2.251,2.251,0,0,0,2.239-2.258v-.421A.625.625,0,0,0,15.13,18.71ZM11.165,3.863a.209.209,0,0,1-.208.209H7.2a.21.21,0,0,1-.209-.209,1.859,1.859,0,0,0-.115-.626h4.4A1.859,1.859,0,0,0,11.165,3.863Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.ac7b7b7682961dc990cd7be0912cdd91.svg";
export { ForwardRef as ReactComponent };